import React from 'react'

interface Props {
  children: React.ReactNode
  /** A second row under the bar — tabs on a detail page. */
  below?: React.ReactNode
  className?: string
}

/**
 * The one band of chrome a page is allowed. It wraps to a second row on its own
 * when its contents don't fit, which is what a resize listener would have been
 * measuring for.
 */
export const PageBarFrame = ({ children, below, className }: Props) => (
  <header
    className={`flex w-full flex-shrink-0 flex-col border-b border-mm-neutral-1-200 bg-white ${
      className ?? ''
    }`}
  >
    <div className="flex w-full flex-wrap items-center gap-x-3 gap-y-2 px-4 py-2">{children}</div>
    {below}
  </header>
)
